import React, { useEffect, useState } from 'react';
import './index.scss';

const BrandPersonalization = ({
    getWebBookingWorfkflow,
    webbookingconfig,
    onSave,
    onCancel,
}) => {
    const [workflow, setWorkflow] = useState({});
    const [textValue, setTextValue] = useState('');
    const [loading, setLoading] = useState(true);
    // Fetch workflow on mount
    useEffect(() => {
        getWebBookingWorfkflow();
    }, [getWebBookingWorfkflow]);

    // Update workflow state when props change
    useEffect(() => {
        if (webbookingconfig.workflow) {
            setWorkflow(webbookingconfig.workflow);
            setTextValue(JSON.stringify(webbookingconfig.workflow, null, 2));
        }
    }, [webbookingconfig.workflow]);

    useEffect(() => {
        if (webbookingconfig.getWorkflow === true) {
            // Start loading
            setLoading(true);
            console.log('loading start');
        } else if (webbookingconfig.getWorkflow === false) {
            // Stop loading and update workflow
            setLoading(false);
            console.log('loading end');
        }
    }, [webbookingconfig.getWorkflow]);
    
    // Handle textarea change
    const handleChange = (e) => {
        setTextValue(e.target.value);

        try {
            const parsed = JSON.parse(e.target.value);
            setWorkflow(parsed);
        } catch (err) {
            // Do nothing, invalid JSON, workflow not updated
        }
    };

    // Disable save if JSON invalid
    const validateSave = () => {
        try {
            JSON.parse(textValue);
            return false; // valid → enable
        } catch {
            return true; // invalid → disable
        }
    };
    const { postWorkflow, postWorkflowFail } = webbookingconfig;
    return (
        <div className="design">
            <div className="workflow_config">
                <textarea
                    value={
                        loading
                            ? 'Loading workflow...' // temporary indicator
                            : textValue
                    }
                    onChange={handleChange}
                    className="json-textarea"
                />
                <div className="actions">
                    <button
                        type="button"
                        className="btn btn--primary btn--md first-button"
                        onClick={(e) => onSave(workflow, 'workflow')}
                        disabled={validateSave() || postWorkflow}
                    >
                        SAVE
                    </button>
                    <button
                        type="button"
                        className="btn btn--link button-cancel"
                        onClick={onCancel}
                    >
                        Cancel
                    </button>
                </div>
                {postWorkflowFail && <div className="error-message">Something went wrong, please try again later</div>}
            </div>
        </div>
    );
};

export default BrandPersonalization;
